import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useState } from 'react';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import formatDuration from 'commons/formatDuration';
import getVideoType from 'commons/getVideoType';
import { GET_VIDEO_METADATA } from 'mocks/queries';
const useVideoMetadata = t0 => {
  const $ = _c(22);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    skip: t2,
    videoId
  } = t1;
  const skip = t2 === undefined ? false : t2;
  const [durationInSeconds, setDurationInSeconds] = useState(0);
  const [thumbnail, setThumbnail] = useState("");
  let t3;
  if ($[2] !== videoId) {
    t3 = getVideoType(videoId);
    $[2] = videoId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const videoType = t3;
  let t4;
  if ($[4] !== videoId || $[5] !== videoType) {
    t4 = {
      id: videoId,
      type: videoType
    };
    $[4] = videoId;
    $[5] = videoType;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = skip || !videoId;
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = {
      variables: t4,
      skip: t5
    };
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const {
    loading,
    data: t7
  } = useSuspenseQuery(GET_VIDEO_METADATA, t6);
  let t8;
  if ($[10] !== t7) {
    t8 = t7 === undefined ? {} : t7;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const data = t8;
  const {
    getVideoMetadata
  } = data;
  let t10;
  let t9;
  if ($[12] !== getVideoMetadata || $[13] !== loading || $[14] !== skip) {
    t9 = () => {
      if (skip || loading || !getVideoMetadata) {
        return;
      }
      if (getVideoMetadata.duration) {
        setDurationInSeconds(getVideoMetadata.duration);
      }
      if (getVideoMetadata.thumbnails.length > 0) {
        const url = getVideoMetadata.thumbnails.length > 3 ? getVideoMetadata.thumbnails[3] : getVideoMetadata.thumbnails[0];
        setThumbnail(url);
      }
    };
    t10 = [getVideoMetadata, loading, skip];
    $[12] = getVideoMetadata;
    $[13] = loading;
    $[14] = skip;
    $[15] = t10;
    $[16] = t9;
  } else {
    t10 = $[15];
    t9 = $[16];
  }
  useEffect(t9, t10);
  let t11;
  if ($[17] !== durationInSeconds) {
    t11 = formatDuration(durationInSeconds);
    $[17] = durationInSeconds;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const duration = t11;
  let t12;
  if ($[19] !== duration || $[20] !== thumbnail) {
    t12 = {
      duration,
      thumbnail
    };
    $[19] = duration;
    $[20] = thumbnail;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
};
export default useVideoMetadata;